import {ClientManagementLayout} from "../../layouts/ClientManagementLayout";
import {Pane} from "evergreen-ui";
import {reduceRelayPaginationAction, RelayPaginationActionPayload, RelayPaginationState} from "../../pagination";
import {SortOrder} from "../../../placement/domains";
import React from "react";
import {ProviderMetricsFilterValue, ProviderMetricsPageState} from "./domain";
import {ProviderMetricList} from "./ProviderMetricList";

const defaultPageSize = 10;

export type ProviderMetricsPageAction =
    | { type: 'SET_FILTER'; filter: ProviderMetricsFilterValue }
    | { type: 'SET_PAGE_SIZE'; pageSize: number }
    | { type: 'SHOW_SUBMIT_INQUIRY_MODAL' }
    | { type: 'HIDE_SUBMIT_INQUIRY_MODAL' }
    | RelayPaginationActionPayload

function initState(): ProviderMetricsPageState {
    const defaultPagination = new RelayPaginationState('0', defaultPageSize)
    return {
        pagination: defaultPagination,
        pageSize: defaultPagination.size,
        showSubmitInquiryModal: false,
        filter: {
            reportType: "",
            reportPeriod: null,
            reportAvailableDateFrom: null,
            reportAvailableDateTo: null,
        },
        sortBy: {
            column: "reportAvailableDate",
            order: SortOrder.DESC,
        }
    }
}

function metricReducer(
    state: ProviderMetricsPageState,
    action: ProviderMetricsPageAction
): ProviderMetricsPageState {
    switch (action.type) {
        case "SET_FILTER":
            const defaultPagination = new RelayPaginationState('0', defaultPageSize);
            return {
                ...state,
                pagination: defaultPagination,
                pageSize: defaultPagination.size,
                filter: action.filter
            };
        case "SET_PAGE_SIZE":
            return {
                ...state,
                pageSize: action.pageSize,
                pagination: new RelayPaginationState('0', action.pageSize),
            };
        case 'RELAY_PAGINATION_ACTION':
            return {
                ...state,
                pagination: reduceRelayPaginationAction(state.pagination, action)
            };
        case 'SHOW_SUBMIT_INQUIRY_MODAL':
            return {
                ...state,
                showSubmitInquiryModal: true
            };
        case 'HIDE_SUBMIT_INQUIRY_MODAL':
            return {
                ...state,
                showSubmitInquiryModal: false
            };
        default:
            return state;
    }
}

export const ProviderMetricsPage = () => {
    const [{
        pagination,
        sortBy,
        filter,
        pageSize,
        showSubmitInquiryModal,
    }, dispatch] = React.useReducer(metricReducer, initState());

    return (
        <ClientManagementLayout customSelection={'Provider Metrics'}>
            <Pane minHeight="calc(100vh - 100px - 260px - 36px)" flexGrow={1}>
                <ProviderMetricList pagination={pagination}
                                    filter={filter}
                                    pageSize={pageSize}
                                    sortBy={sortBy}
                                    showSubmitInquiryModal={showSubmitInquiryModal}
                                    dispatch={dispatch}/>
            </Pane>
        </ClientManagementLayout>
    )
}
